<div
    class="malou-text-34--bold md:malou-text-20--bold uppercase text-malou-text-title md:leading-tight"
    [class.font-passion-one]="!partnerTheme()"
    [style.font-family]="partnerTheme()?.titleFont ?? null"
    [innerHTML]="
        doesYourSocialPlatformAccountPerformBetterThanCompetitors()
            ? (i18nPrefix() + '.title.better_than_competitors' + keySuffix() | translate)
            : (i18nPrefix() + '.title.worst_than_competitors' + keySuffix() | translate)
    "></div>
<div class="mt-12 flex w-full gap-5 md:flex-col">
    <div class="flex w-1/2 flex-col gap-2 md:w-full">
        <div
            [ngClass]="{
                'mb-3 w-full': true,
                'rounded-[5px] py-2 text-center text-sm font-bold text-white': !!partnerTheme(),
                'malou-custom-box': !partnerTheme(),
            }"
            [style.background-color]="partnerTheme()?.header?.secondaryColor ?? null">
            {{ socialPlatformDisplayName() }}
        </div>
        <app-social-network-rating-box
            [isDiagnosticRestaurant]="true"
            [value]="socialNetworkDiagnosticResult().followers"
            [description]="i18nPrefix() + '.followers' | translate"
            [diagnosticRating]="socialPageDiagnosticRating()?.followersDiagnosticRating">
        </app-social-network-rating-box>
        <app-social-network-rating-box
            [isDiagnosticRestaurant]="true"
            [value]="socialNetworkDiagnosticResult().averageLikeCount"
            [description]="i18nPrefix() + '.last_month_average_like' | translate"
            [diagnosticRating]="socialPageDiagnosticRating()?.likesDiagnosticRating">
        </app-social-network-rating-box>
        <app-social-network-rating-box
            [isDiagnosticRestaurant]="true"
            [value]="socialNetworkDiagnosticResult().postCount"
            [description]="i18nPrefix() + '.last_month_post_count' | translate"
            [diagnosticRating]="socialPageDiagnosticRating()?.postCountDiagnosticRating">
        </app-social-network-rating-box>
    </div>
    <div class="flex w-1/2 flex-col gap-2 md:w-full">
        <div
            [ngClass]="{
                'mb-3 w-full': true,
                'rounded-[5px] py-2 text-center text-sm font-bold text-white': !!partnerTheme(),
                'malou-custom-box': !partnerTheme(),
            }"
            [style.background-color]="partnerTheme()?.header?.secondaryColor ?? null">
            {{ 'maloupe.diagnostic_result.competitors.competitors' | translate }}
        </div>
        <app-social-network-rating-box
            [isDiagnosticRestaurant]="false"
            [value]="socialNetworkDiagnosticResult().averageFollowerCountForSimilarRestaurants"
            [description]="i18nPrefix() + '.competitors_last_month_follower_count' + keySuffix() | translate">
        </app-social-network-rating-box>
        <app-social-network-rating-box
            [isDiagnosticRestaurant]="false"
            [value]="socialNetworkDiagnosticResult().averageLikeCountForSimilarRestaurants"
            [description]="i18nPrefix() + '.competitors_last_month_like_count' + keySuffix() | translate">
        </app-social-network-rating-box>
        <app-social-network-rating-box
            [isDiagnosticRestaurant]="false"
            [value]="socialNetworkDiagnosticResult().averagePostCountForSimilarRestaurants"
            [description]="
                (socialNetworkDiagnosticResult().averagePostCountForSimilarRestaurants > MINIMUM_POST_COUNT_RECOMMENDATION
                    ? i18nPrefix() + '.competitors_last_month_post_count' + keySuffix()
                    : i18nPrefix() + '.post_count_recommendation' + keySuffix()
                ) | translate
            ">
        </app-social-network-rating-box>
    </div>
</div>
